/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

// const plyrsInit = function () {
//   const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

//   if (!plyrs) {
//     return;
//   }

//   plyrs.forEach(function (el) {
//     let plyr = el.querySelector(".mediavideo__video");
//     new Plyr(plyr, {
//       controls: ["play", "progress", "mute", "current-time"],
//       hideControls: true,
//       invertTime: false,
//       tooltips: { controls: false, seek: false }
//     });
//   });
// }; // plyrsInit();

// plyrsInit();

/*  ==========================================================================
  GENERAL - Companies Filter
========================================================================== */

const companiesShuffleContainer = document.querySelector(".main--companies .companies");

const companiesFilter = [];

companiesFilter.status = document.querySelectorAll(".filters--company .filter__option--status");
companiesFilter.industry = document.querySelectorAll(".filters--company .filter__option--industry");
companiesFilter.stage = document.querySelectorAll(".filters--company .filter__option--stage");

const companiesFilterOptions = document.querySelectorAll(".filters--company .filter__option");

let shuffleInstance = false;

const companyFilterActiveOptions = function () {
  const allFilterOptions = document.querySelectorAll(".filters__active__option");
  allFilterOptions.forEach(option => {
    option.addEventListener("click", function () {
      let filter_option = option.dataset.option;
      let filter_input = document.querySelector(".filter__option[data-option='" + filter_option + "']");

      if (filter_input) {
        filter_input.classList.remove("active");
      }
      // Remove option
      option.remove();
      // Trigger filter
      companyFilterGetCompanies();
    });
  });
};

const companyFilterSetupClearAll = function () {
  const filterClearAll = document.querySelector(".filters__clearall");

  filterClearAll.addEventListener("click", function () {
    companiesFilterOptions.forEach(el => el.classList.remove("active"));

    // Remove all active options
    document.querySelector(".filters__active").classList.remove("filters__active--active");
    document.querySelector(".filters__active__options").innerHTML = "";

    // Make "all" active
    document.querySelector(".filter__option--all").classList.add("active");

    companyFilterGetCompanies();
  });
};

const companyFilterGetCompanies = function () {
  let activeOptions = false;
  const currentSelectOptions = [];

  companiesFilterOptions.forEach(el => {
    if (el.classList.contains("active") && el.dataset.option !== "") {
      currentSelectOptions.push(el.dataset.option);
      activeOptions = true;
    }
  });

  // If there is active options
  if (activeOptions) {
    document.querySelector(".filters__active").classList.add("filters__active--active");

    companyFilterActiveOptions();
  } else {
    // If there is not then hide active options section
    document.querySelector(".filters__active").classList.remove("filters__active--active");
    document.querySelector(".filters__active__options").innerHTML = "";

    // Make "all" active
    document.querySelector(".filter__option--all").classList.add("active");
  }

  shuffleInstance.filter(currentSelectOptions);

  const companiesNoitems = document.querySelector(".companies__noitems");
  if (companiesNoitems) {
    if (shuffleInstance.visibleItems <= 0) {
      document.querySelector(".companies__noitems").classList.add("show");
    } else {
      document.querySelector(".companies__noitems").classList.remove("show");
    }
  }
};

const companyFilterInit = function () {
  if (!companiesShuffleContainer || !companiesFilterOptions) {
    return;
  }

  const filterMobileToggle = document.querySelectorAll(".filters__optionset");

  filterMobileToggle.forEach(el => {
    el.addEventListener("click", function () {
      this.classList.toggle("open");
    });
  });

  shuffleInstance = new Shuffle(companiesShuffleContainer, {
    itemSelector: ".tile__selector",
    filterMode: Shuffle.FilterMode.ALL,
    sizer: ".tile__sizer"
  });

  // When items finish moving refresh waypoints
  shuffleInstance.on(Shuffle.EventType.LAYOUT, () => {
    Waypoint.refreshAll();
  });

  companiesFilterOptions.forEach(option => {
    option.addEventListener("click", function () {
      if (this.classList.contains("active")) {
        // it's already active
        return;
      }

      // If filter type is State the we remove any other options selected
      if (
        this.dataset.filter &&
        this.dataset.filter === "status" &&
        companiesFilter &&
        companiesFilter[this.dataset.filter]
      ) {
        // Removing all other active filters in "State"
        companiesFilter[this.dataset.filter].forEach(el => {
          el.classList.remove("active");

          //Removing the active tag options
          let filterActiveOption = document.querySelector(
            ".filters__active__option[data-option='" + el.dataset.option + "']"
          );
          if (filterActiveOption) {
            filterActiveOption.remove();
          }
        });
      }

      this.classList.add("active");

      if (this.dataset.option !== "") {
        document.querySelector(
          ".filters__active__options"
        ).innerHTML += `<div class="filters__active__option" data-option="${this.dataset.option}">${this.textContent} <i class="fal fa-times"></i></div>`;
      }

      companyFilterGetCompanies();
    });
  });

  // Setting up clearall button
  companyFilterSetupClearAll();
};
companyFilterInit();

/*  ==========================================================================
  GENERAL - Annoucenment Bar
========================================================================== */
const announcementInit = function () {
  const announcementClose = document.querySelector(".announcement__close");
  const announcementBar = document.querySelector(".announcement");

  if (!announcementClose) {
    return;
  }

  if (!sessionStorage.getItem("announcementDismissed")) {
    announcementBar.classList.remove("disabled");
  }

  announcementClose.addEventListener("click", function (e) {
    announcementBar.classList.add("disabled");

    sessionStorage.setItem("announcementDismissed", true);
  });
};
announcementInit();
/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink:not(.sociallink--external)");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");

      if (this.classList.contains("sociallink--copytoclipboard")) {
        const copytoclipboardText = this.querySelector(".sociallink__text");

        navigator.clipboard.writeText(shareURL).then(
          () => {
            // alert('Content copied to clipboard');
            copytoclipboardText.innerHTML = "Link copied to clipboard";
            copytoclipboardText.classList.add("show");
            setTimeout(() => {
              copytoclipboardText.classList.remove("show");
            }, 2000);
            /* Resolved - text copied to clipboard successfully */
          },
          () => {
            // alert('Failed to copy');
            copytoclipboardText.innerHTML = "Failed to copy link";
            copytoclipboardText.classList.add("show");
            setTimeout(() => {
              copytoclipboardText.classList.remove("show");
            }, 2000);
            /* Rejected - text failed to copy to the clipboard */
          }
        );
      } else {
        var w = 550;
        var h = 550;
        var left = Number(screen.width / 2 - w / 2);
        var tops = Number(screen.height / 2 - h / 2);
        window.open(
          shareURL,
          "share-dialog",
          "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
        );
      }
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */

const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false // Disable thumbnails
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
    GENERAL - Accordion & Media
  ========================================================================== */

const setActiveItem = function (accordionMediaItems, item) {
  accordionMediaItems.forEach(el => {
    el.classList.remove("active");
    el.querySelector(".item__inner").style.height = "0px";
  });
  item.classList.add("active");
  let innerHeight = item.querySelector(".item__leader").offsetHeight;
  item.querySelector(".item__inner").style.height = innerHeight + "px";
};

const accordionMediaInit = function () {
  const accordionMedia = document.querySelectorAll(".module--accordion-media");

  if (!accordionMedia) {
    return;
  }

  accordionMedia.forEach(module => {
    const accordionMediaItems = module.querySelectorAll(".accordion-media__item");

    if (!accordionMediaItems) {
      return;
    }

    accordionMediaItems.forEach(item => {
      item.addEventListener("click", function () {
        setActiveItem(accordionMediaItems, this);
      });
    });

    // set first item as active on load
    setActiveItem(accordionMediaItems, accordionMediaItems[0]);

    window.addEventListener(
      "resize",
      function (event) {
        setActiveItem(accordionMediaItems, module.querySelector(".accordion-media__item.active"));
      },
      true
    );
  });
};
accordionMediaInit();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.textContent; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.textContent = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page

  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts

        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }
  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }
  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    var scrollPosition = window.pageYOffset;
    localStorage.setItem("scrollPosition", scrollPosition);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "95%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='fal fa-long-arrow-left'></i>", "<i class='fal fa-long-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();

    let mobnavHeight = 0;
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      mobnavSetHeight();
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...
      mobnav.style.height = 0;
      body.classList.remove(mobnavOpenclass);
    }
  });
}; // mobnavInit()
mobnavInit();

// On resize check mobnav height is still right
const mobnavResize = function () {
  let mobnavHeight = 0;
  if (body.classList.contains(mobnavOpenclass)) {
    mobnavSetHeight();
  }
}; // mobnavResize()

window.addEventListener(
  "resize",
  function (event) {
    mobnavResize();
  },
  true
);

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__link");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = e.target.closest(".sitenav__item");
      mobnavTargetSection.classList.toggle("sitenav__item--open");
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
	NAVIGATION - Search
	========================================================================== */

// Search open & close
const searchNav = document.querySelector(".siteheader__search");
const searchToggle = document.querySelector(".search-toggle");
const searchInput = document.querySelector(".siteheader__search .searchform__input input");

// Close search modal when clicked elsewhere in the document
const clickedOusideSearch = function (e) {
  if (!searchNav.classList.contains("siteheader__search--open")) {
    return;
  }

  var isClickInsideElement =
    searchNav.contains(e.target) || searchToggle === e.target || searchToggle.contains(e.target);

  if (!isClickInsideElement) {
    searchNav.classList.remove("siteheader__search--open");
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  }
}; // clickedOusideSearch();

// Toggle search modal window
const searchModalToggle = function (e) {
  e.preventDefault();
  if (searchNav.classList.contains("siteheader__search--open")) {
    searchNav.classList.remove("siteheader__search--open");
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  } else {
    searchNav.classList.add("siteheader__search--open");
    searchInput.focus();
    body.addEventListener("mouseup", clickedOusideSearch, false);
  }
}; // searchModalToggle();

const searchModalInit = function () {
  if (!searchNav) {
    return;
  }
  searchToggle.addEventListener("click", searchModalToggle);
}; // searchModalInit();

searchModalInit();
